import helpers from '../../utils/helpers';
import BleService from "../ble/BleService";

export default class FwuDataClient {
    constructor({ program_blocks, onLastFrame, onFail, sendStatusMessage, deviceId }) {
        this.program_blocks = program_blocks;
        this.device = undefined;
        this.isStopped = true;
        this.onFail = onFail;
        this.onLastFrame = onLastFrame;
        this.previousWriteTS = Date.now();
        this._currentFrameIndex = 0;
        this.sendStatusMessage = sendStatusMessage;
        this.deviceId = deviceId;
    }

    set currentFrameIndex(val) {
        this._currentFrameIndex = val;
    }

    get currentFrameIndex() {
        return this._currentFrameIndex;
    }

    writeFwuFrames = async () => {

        if (!this.device) {
            const bleService = new BleService();
            this.device = bleService.getDevice(this.deviceId);
        }

        if (!this.device.isDeviceConnected()) {
            console.debug(`FwuDataClient: FWU Frame - ${this.currentFrameIndex}: Device is not connected`);
            this.onFail("Device disconnected");
            return;
        }

        if (this.isStopped) return;

        const { program_blocks } = this;
        const frame = program_blocks[this.currentFrameIndex];
        const { f, n } = frame;

        try {
            // console.debug(`FwuDataClient: FWU Frame - ${f}: try to writeValue`);
            const WRITE_INTERVAL_MS = 89;
            const interval = Date.now() - this.previousWriteTS;
            const delay = WRITE_INTERVAL_MS - interval;

            if (delay > 0 && delay < WRITE_INTERVAL_MS) {
                await helpers.timeout(delay);
            }
            if (this.isStopped) return;

            this.previousWriteTS = Date.now();
            await this.device.writeValueToFwuDataCharacteristic(f);

            if (this.isStopped) return;

            console.debug(`FwuDataClient: FWU Frame - ${f}, Frame Index - ${this.currentFrameIndex}: writeValue success`);

            if (n) {
                this.sendStatusMessage(n);
            }


            const isLastFrame = this.isLastFrame();

            if (isLastFrame) {
                helpers.runFunction(this.onLastFrame(frame));
            } else {
                this.currentFrameIndex = this.currentFrameIndex + 1;
                this.writeFwuFrames();
            }

        } catch (error) {
            if (this.isStopped) return;
            console.debug(`FwuDataClient: FWU Frame - ${f}: writeValue error: ${error}`);
            this.onFail(`FwuDataClient: error: ${error}`);
        }
    };

    isLastFrame = () => {
        return this.currentFrameIndex >= this.program_blocks.length - 1;
    };

    start = (frameIndex) => {
        this.isStopped = false;
        this.currentFrameIndex = frameIndex;
        this.writeFwuFrames();
    };

    stop = () => {
        this.isStopped = true;
    };
}